import axios from "@/api/axios"
import utils from '@/utils/index';
export default function(obj = {}) {
    axios.get('/oss').then(res => {
        if (res.data.code == 200 && res.data.success) {
            var data = res.data.data
            var fileName = data.dir + new Date().getTime() + '-' + utils.getUUID() + '.' + utils.getSuffix(obj.name)
            var ossData = new FormData()
            ossData.append('key', fileName)
            ossData.append('policy', data.policy)
            ossData.append('OSSAccessKeyId', data.accessid)
            ossData.append('success_action_status', 200)
            ossData.append('signature', data.signature)
            ossData.append('file', obj.file)
            axios.post(data.host, ossData).then(res1 => {
                if (res1.status == 200) {
                    obj.success({ code: 200, data: { url: data.host + '/' + fileName }, success: true })
                } else {
                    obj.error({ code: 200, success: false, msg: '上传失败' })
                }
            }).catch(err => {
                obj.error({ code: 200, success: false, msg: '上传失败', data: err })
            })
        } else {
            obj.error(res.data)
        }
    }).catch(err => {
        obj.error({ code: 200, success: false, msg: '上传失败', data: err })
    })
}